import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { useLocalizedStrings } from 'app/localization/Context';
import { DeviceList } from 'app/home/main-pages/devices/Devices';
import { CurrentPageContext, HistoryStackContext } from 'app/home/general-components/HistoryStackContext';
import Popup, { usePopup } from 'app/home/general-components/Popup/Popup';
import { AskText, ColorSelector } from '../../device/deivce-detail/DeviceDetail';
import { RoomIcon } from 'app/home/home-components/room-header-tab/RoomHeaderTab';

import CustomIconBack from 'app/home/home-components/CustomIconBack';

import { ReactComponent as IconTick } from 'images/general/tick.svg';
import { ReactComponent as IconDeleteWhite } from 'images/general/delete-white.svg';
import { ReactComponent as IconSettings } from 'images/setting/settings-gear.svg';
import { ReactComponent as IconEditDevice } from 'images/setting/settings-gears.svg';
import { ReactComponent as IconDeleteRed } from 'images/general/delete-red.svg';
import { ReactComponent as IconBackBlack } from 'images/general/back-black.svg';

// export function AddRoom({ }) {
//     return null;
// }

export function RoomDetail({ roomsData, currentUser, roomsController, devices }) {
    const hs = useContext(HistoryStackContext);
    const p = useContext(CurrentPageContext);
    const dismissHandler = p.dismiss;
    const selectedRoomId = p.state.selectedRoomId;

    const s = useLocalizedStrings();
    const r = s.rooms;

    const settingPermission = currentUser.permissions.setting;

    const room = roomsData.rooms[selectedRoomId];

    const [roomCache, setRoomCache] = useState(room);
    useEffect(() => {
        if (room !== undefined) {
            setRoomCache(room);
        }
    }, [room]);

    const [popupId, showPopup, dismissPopup] = usePopup();
    const removeClick = useCallback(() => {
        dismissPopup();
        setTimeout(() => {
            dismissHandler();
            roomsController.removeRoom(roomCache.room_id);
        });
    }, [roomsController, dismissHandler, roomCache.room_id, dismissPopup]);

    return (
        <div className="room-detail-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="room-detail-page-content">
                <div className="header-group">
                    <CustomIconBack className="back-icon" />
                    <div />
                    {
                        settingPermission ? (
                            <Fragment>
                                <div className="button-border"
                                    onClick={() => {
                                        hs.push(
                                            "/settings/rooms_management/detail/settings",
                                            { roomId: room.room_id })
                                    }}>
                                    <div className="label">{r.settings}</div>
                                    <IconSettings className="icon" />
                                </div>
                                <IconDeleteWhite className="remove-icon" onClick={showPopup} />
                            </Fragment>
                        ) : null
                    }
                </div>
                <div className="nav-button" onClick={dismissHandler} />
                <div className="page-header with-margin-bottom">
                    {roomCache.name}
                </div>

                <div className="section">
                    <div className="header">
                        <div className="title">{r.selectedDevices}</div>
                        <div />
                        {settingPermission ? (
                            <div className="button"
                                onClick={() => {
                                    hs.push("/settings/rooms_management/detail/edit_devices", { roomId: room.room_id })
                                }}>
                                <div className="label">{r.editDevices}</div>
                                <IconEditDevice className="icon" />
                            </div>
                        ) : null}
                    </div>
                    <div className="content">
                        <DeviceList
                            style={{ marginTop: 8 }}
                            bottomPaddingSize={16} // +8 for safe-area
                            devices={devices}
                            showStates={true} showSubDevices={true}
                            filterMacs={roomCache["device_macs"]}
                            key={"room_detail_device_list_of_room"}
                        />
                    </div>
                </div>

                <Popup popupId={popupId} name="remove_room_popup" baseZIndex={12}>
                    <div className="room-remove-popup">
                        <div className="header">{r.removeAreYouSure}</div>
                        <div className="buttons-group">
                            <div className="delete-button" onClick={removeClick}>
                                <div className="label">{r.removeConfirmOK}</div>
                                <IconDeleteRed className="icon" />
                            </div>
                            <div className="dismiss-button" onClick={dismissPopup}>{r.removeConfirmNO}</div>
                        </div>
                    </div>
                </Popup>
            </div>
        </div>
    );
}

export function RoomSelectDevice({
    createRoomMode, createRoomModeBackHandler, setSelectedMacsCallback, defaultSelectedMacs,
    devices, roomsData, roomsController }) {
    const s = useLocalizedStrings();
    const r = s.rooms;

    const p = useContext(CurrentPageContext);
    const roomId = p.state.roomId;
    const roomMacs = createRoomMode ? defaultSelectedMacs : roomsData.rooms[roomId]["device_macs"];
    const backHandler = createRoomMode ? (createRoomModeBackHandler) : (p.dismiss);

    const [selectedDevices, setSelectedDevices] = useState(roomMacs);

    const selectionCallback = useCallback(device => {
        const newSelectedDevices = [...selectedDevices];
        const index = selectedDevices.findIndex((m) => m === device.mac);
        if (index >= 0) {
            newSelectedDevices.splice(index, 1);
        } else {
            newSelectedDevices.push(device.mac);
        }
        setSelectedDevices(newSelectedDevices);
    }, [selectedDevices]);

    const save = useCallback(() => {
        roomsController.changeRoom({ "room_id": roomId, "device_macs": selectedDevices });
        backHandler();
    }, [selectedDevices, roomId, backHandler, roomsController]);
    const next = useCallback(() => {
        setSelectedMacsCallback(selectedDevices);
    }, [setSelectedMacsCallback, selectedDevices]);

    return (
        <div className="room-detail-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="room-detail-page-content edit-deivces">
                <div className="header-group">
                    <CustomIconBack className="back-icon" />
                </div>
                <div className="nav-button" onClick={backHandler} />
                <div className="page-header with-margin-bottom">
                    {createRoomMode ? r.selectDevices : r.editDevices}
                </div>
                <div className="page-header-info" style={{ marginBottom: 16 }}>
                    {createRoomMode ? r.selectDevicesInfo : r.editDevicesInfo}
                </div>

                <div className="the-rest-of-page-container with-full-button-margin">
                    <DeviceList
                        devices={devices}
                        selectedDevices={selectedDevices}
                        selectionCallback={selectionCallback}
                        showStates={false}
                        dontOpenSettings={true}
                        showSubDevices={false}
                        // bottomPaddingSize={8 + 64}
                        key={"room_device_list_edit_devices"} />
                </div>

                {
                    createRoomMode ? (
                        <div className="full-blue-button next-button" onClick={next}>
                            <div>{r.next}</div> <IconBackBlack className="icon-180" />
                        </div>
                    ) : (
                        <div className="full-blue-button next-button" onClick={save}>
                            <div>{r.save}</div> <IconTick className="icon" />
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export function RoomSelectNameAndIcon({
    createRoomMode, createRoomModeBackHandler, setInfoCallback,
    roomsData, roomsController }) {

    const s = useLocalizedStrings();
    const r = s.rooms;

    const p = useContext(CurrentPageContext);
    const roomId = p.state.roomId;
    const backHandler = createRoomMode ? (createRoomModeBackHandler) : (p.dismiss);

    let _name = "";
    let _avatar = 5;
    let _colorIndex = 0;
    if (roomId !== undefined) {
        const room = roomsData.rooms[roomId];
        _name = room.name;
        _avatar = room.avatar;
        _colorIndex = room.color;
    }

    const [tempNameForCreation, setTempNameForCreation] = useState("");
    const [avatar, _setAvatar] = useState(_avatar);
    const [colorIndex, _setColorIndex] = useState(_colorIndex);

    const setAvatar = useCallback((a) => {
        _setAvatar(a);
        if (!createRoomMode) {
            roomsController.changeRoom(
                { room_id: roomId, avatar: a }
            )

        }
    }, [createRoomMode, roomsController, roomId]);

    const setColorIndex = useCallback((c) => {
        _setColorIndex(c);
        if (!createRoomMode) {
            roomsController.changeRoom(
                { room_id: roomId, color: c }
            )
        }
    }, [createRoomMode, roomsController, roomId]);

    const done = useCallback(() => {
        if (tempNameForCreation.length > 0) {
            setInfoCallback(tempNameForCreation, avatar, colorIndex);
        }
    }, [setInfoCallback, tempNameForCreation, avatar, colorIndex]);

    return (
        <div className="room-detail-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="room-detail-page-content select-info">
                <div className="header-group">
                    <CustomIconBack className="back-icon" />
                </div>
                <div className="nav-button" onClick={backHandler} />
                <div className="page-header with-margin-bottom">
                    {createRoomMode ? r.chooseNameAndIcon : r.settings}
                </div>

                {/* NAME */}
                {
                    createRoomMode ? (
                        <Fragment>
                            <div className="input-label">{r.name}</div>
                            <div className="input-box-container" style={{ gridTemplateColumns: "1fr" }}>
                                <input className="input-box" placeholder={r.namePlaceholder}
                                    value={tempNameForCreation} onChange={e => setTempNameForCreation(e.target.value)}></input>
                            </div>
                        </Fragment>
                    ) : (
                        <AskText
                            header={r.name}
                            originalText={_name}
                            sendText={(n) => {
                                roomsController.changeRoom(
                                    { room_id: roomId, name: n }
                                )
                            }} />
                    )
                }

                {/* ICON */}
                <div className="input-label" style={{ marginTop: 24 }}>{r.icon}</div>
                <div className="icon-list">
                    {
                        [5, 1, 6, 3, 4, 2, 13, 12, 8, 10, 7, 11, 9].map((i) => {
                            let containerStyle = {};
                            if (avatar === i) {
                                containerStyle = { borderColor: "#ffffff" };
                            }

                            return (
                                <div
                                    onClick={() => {
                                        if (avatar !== i) {
                                            setAvatar(i);
                                        }
                                    }}
                                    className="icon-container"
                                    style={containerStyle}
                                    key={"create-room-icon-" + String(i)}>
                                    <RoomIcon avatar={i} className="icon" />
                                </div>
                            );
                        })
                    }
                </div>

                {/* COLOR */}
                <div className="input-label" style={{ marginTop: 24 }}>{r.color}</div>
                <ColorSelector selectedColorCode={colorIndex} setColorCode={setColorIndex} />

                {
                    createRoomMode ? <Fragment>
                        <div style={{ marginBottom: 64 + 8 }} />
                        <div
                            className={"full-blue-button next-button" + (tempNameForCreation.length === 0 ? " with-error" : "")}
                            onClick={done}>
                            <div>{r.add}</div> <IconTick className="icon" />
                            {(tempNameForCreation.length === 0) ? (
                                <div className="error-label"> {r.mustEnterAName} </div>
                            ) : null}
                        </div>
                    </Fragment> : null
                }
            </div>
        </div>
    );
}
